import { combineReducers } from 'redux'

import list from './list/slice'

const entriesReducer = combineReducers({
  list,
})

export default entriesReducer
